import { render, staticRenderFns } from "./MateriaTable.vue?vue&type=template&id=357849b9&scoped=true&"
import script from "./MateriaTable.vue?vue&type=script&lang=js&"
export * from "./MateriaTable.vue?vue&type=script&lang=js&"
import style0 from "./MateriaTable.vue?vue&type=style&index=0&id=357849b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357849b9",
  null
  
)

export default component.exports